module.exports = __webpack_public_path__ + "img/data-center-border.e8738b85.png";